import React from 'react';
import type { FormInstance } from 'antd';
import { Form } from 'antd';
import BoldOutlined from '@ant-design/icons/BoldOutlined';
import ItalicOutlined from '@ant-design/icons/ItalicOutlined';
import UnderlineOutlined from '@ant-design/icons/UnderlineOutlined';
import { RibbonIconButton } from '../bookDefaultStyles/WordStyleRibbon';
import { FormToggleIconButton } from './FormToggleIconButton';
import { styleFieldName } from '../../utils/styleFormFieldNames';

type Props = {
  form: FormInstance;
  namePrefix?: string | string[];
};

export const FontWeightToggleButtons: React.FC<Props> = ({ form, namePrefix }) => {
  const fontWeight = Form.useWatch(styleFieldName(namePrefix, 'fontWeight'), form) ?? 400;

  return (
    <div className="word-ribbon-inline">
      {[
        { value: 400, title: 'Normal', label: 'N' },
        { value: 600, title: 'SemiBold', label: 'SB' },
        { value: 700, title: 'Bold', label: 'B' },
      ].map(({ value, title, label }) => (
        <RibbonIconButton
          key={value}
          title={title}
          active={Number(fontWeight) === value}
          className={value >= 600 && Number(fontWeight) === value ? 'word-ribbon-icon-btn--bold' : undefined}
          onClick={() => form.setFieldValue(styleFieldName(namePrefix, 'fontWeight'), value)}
        >
          {value === 400 ? label : <BoldOutlined />}
        </RibbonIconButton>
      ))}
    </div>
  );
};

export const ItalicUnderlineToggles: React.FC<Props> = ({ namePrefix }) => (
  <div className="word-ribbon-inline">
    <Form.Item
      name={styleFieldName(namePrefix, 'italic')}
      valuePropName="checked"
      initialValue={false}
      noStyle
    >
      <FormToggleIconButton title="Italic" effect="italic" className="italic-btn">
        <ItalicOutlined />
      </FormToggleIconButton>
    </Form.Item>
    <Form.Item
      name={styleFieldName(namePrefix, 'underline')}
      valuePropName="checked"
      initialValue={false}
      noStyle
    >
      <FormToggleIconButton title="Underline" effect="underline">
        <UnderlineOutlined />
      </FormToggleIconButton>
    </Form.Item>
  </div>
);
